<div>
    <div class="mat-subheading-1" style="padding-left: 12px;">
        Change password
    </div>
    <mat-dialog-content style="height: 340px;">
        <form id="formContainer"  [formGroup]="changePasswordForm" >
          <mat-form-field appearance="outline" style="padding-left: 12px;padding-top: 20px; width: 90%;">
            <mat-label>Current Password</mat-label>
            <input matInput [(ngModel)]="currentPassword" (focus)="this.changePasswordForm.controls['currentPassword'].markAsTouched();" (keydown.space)="$event.preventDefault()"  maxlength="15" #currentPasswordInput
            [type]="current_hide ? 'password' : 'text'" formControlName="currentPassword" (keypress)="keyPressPassword($event)" required>
            <div  style="cursor:pointer" mat-icon-button matSuffix (click)="current_hide = !current_hide" [attr.aria-label]="'Hide password'"  *ngIf="!(changePasswordForm.controls['currentPassword'].invalid && changePasswordForm.controls['currentPassword'].touched)">
                <mat-icon>{{current_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </div>
              <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(changePasswordForm.controls['currentPassword'].invalid && changePasswordForm.controls['currentPassword'].touched)" >
                <mat-icon style="color: red;">   
                  <span class="material-icons-outlined">
                      error_outline
                  </span>
                </mat-icon>
              </div>
              <mat-hint class="error-hint"  [ngClass]="{'error-hint': (changePasswordForm.controls['currentPassword'].hasError('invalidPassword') 
              && changePasswordForm.controls['currentPassword'].touched) , 'normal-hint': !(changePasswordForm.controls['currentPassword'].hasError('invalidPassword') 
              && changePasswordForm.controls['currentPassword'].touched) }">
              8-15 characters, with at least one number, special, uppercase, and lowercase characters
              </mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" style="padding-left: 12px;padding-top: 20px; width: 90%;">
            <mat-label>New Password</mat-label>
            <input matInput [(ngModel)]="newPassword" (focus)="this.changePasswordForm.controls['newPassword'].markAsTouched();" (keydown.space)="$event.preventDefault()"  maxlength="15" #newPasswordInput
            [type]="hide ? 'password' : 'text'" formControlName="newPassword" (keypress)="keyPressPassword($event)" required>
            <div  style="cursor:pointer" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"  *ngIf="!(changePasswordForm.controls['newPassword'].invalid && changePasswordForm.controls['newPassword'].touched)">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </div>
              <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(changePasswordForm.controls['newPassword'].invalid && changePasswordForm.controls['newPassword'].touched)" >
                <mat-icon>   
                  <span class="material-icons-outlined" style="color: red;">
                    error_outline
                  </span>
                </mat-icon>
              </div>
              <mat-hint class="error-hint"  [ngClass]="{'error-hint': (changePasswordForm.controls['newPassword'].hasError('invalidPassword') 
              && changePasswordForm.controls['newPassword'].touched) , 'normal-hint': !(changePasswordForm.controls['newPassword'].hasError('invalidPassword') 
              && changePasswordForm.controls['newPassword'].touched) }">
              8-15 characters, with at least one number, special, uppercase, and lowercase characters
              </mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" style="padding-left: 12px;padding-top: 20px; width: 90%;">
            <mat-label>Confirm password</mat-label>
            <input (focus)="this.changePasswordForm.controls['confirmPassword'].markAsTouched();" (keydown.space)="$event.preventDefault()" matInput maxlength="15" #confirmPasswordInput 
            [type]="confirmhide ? 'password' : 'text'" formControlName="confirmPassword" (keypress)="keyPressPassword($event)" required>
            <div  style="cursor:pointer" mat-icon-button matSuffix (click)="confirmhide = !confirmhide" [attr.aria-label]="'Hide password'" *ngIf="!(changePasswordForm.controls['confirmPassword'].invalid && changePasswordForm.controls['confirmPassword'].touched)">
              <mat-icon>{{confirmhide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
              <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(changePasswordForm.controls['confirmPassword'].invalid && changePasswordForm.controls['confirmPassword'].touched)" >
                <mat-icon style="color: red;">   
                  <span class="material-icons-outlined">
                    error_outline
                  </span>
                </mat-icon>
              </div>
              <mat-hint class="error-hint" 
              *ngIf="changePasswordForm.controls['confirmPassword'].hasError('mismatch') && !(changePasswordForm.controls['confirmPassword'].hasError('invalidPassword') )">Password do not match
              </mat-hint>
          </mat-form-field>
        </form>
  </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="onCancel()" mat-dialog-close>CANCEL</button>
        <button mat-button color="primary"   (click)="onConfirm()" [disabled]="(changePasswordForm.invalid)">SAVE</button>
     </mat-dialog-actions>
</div>

